<template lang="pug">
.channel-list.inset(
  v-nv:scope="'channel-list'",
  @nv-noway-left="!single && section('categories')",
  data-right="channel-guide",
  @nv-down="moveList",
  @nv-up="moveList",
  @nv-ch_up="moveList",
  @nv-ch_down="moveList",
  @nv-enter="choose",
  @nv-scope-focus="focused",
  @nv-scope-blur="blured",
  @nv-back="section()",
  @nv-info="section()",
  @nv-numpad="$channelSelectWithNumber",
  :class="{ pushed, single }"
)
  .left-side(v-nv.current, :class="{ 'border-right': !isEpgActive, 'surface-bg-darker-90':transparent, 'surface-bg-darker':!transparent  }")
    pr-text.nochannel(size="medium", v-show="!hasChannel")
      i.fi.flaticon-television-1.mr-3
      | No available channel
    channelItem(
      v-for="(item, index) in lazyChannels",
      :single="single",
      :data="item",
      :key="index",
      :background="index === 3",
      :class="{ activeItem: index === 3 }"
    )
  pr-wrapper.right-side(bg="overlayFrom", v-if="isEpgActive")
    channelGuide(v-if="isEpgActive === 'guide'")
    channelNextProgram(v-else)
</template>

<script>
import { mapGetters } from "vuex"
import channelItem from "./channel-item.vue"
import channelGuide from "./channel-guide.vue"
import channelNextProgram from "./channel-nextProgram.vue"
export default {
  name: "channel-list",
  components: { channelItem, channelGuide, channelNextProgram },
  data() {
    return {
      activeItem: 0
    }
  },
  computed: {
    transparent() {
      return __.device.config("tv_list_behaviour.tv_list_behaviour") === "transparent"
    },
    isEpgActive() {
      return __.device.config("catchup.epg")
    },
    hasChannel() {
      return this.channels.length > 0
    },
    activeChannel() {
      return this.lazyChannels[3]
    },
    lazyChannels() {
      let start = _$.untilZero(this.activeItem - 3),
        end = this.activeItem + 4,
        selected = this.channels.slice(start, end)

      let prepend = new Array(_$.untilZero(3 - this.activeItem)).fill(null, 0),
        diff = 7 - [...prepend, ...selected].length,
        append = new Array(diff).fill(null, 0)

      if (this.channels.length >= 7) {
        if (append.length) append = this.channels.slice(0, append.length)
        if (prepend.length) prepend = this.channels.slice(-prepend.length)
      }

      return [...prepend, ...selected, ...append]
    },
    pushed() {
      return this.sidebar === "categories"
    },
    ...mapGetters("live", ["channels", "channel", "sidebar", "category", "single"])
  },
  watch: {
    channel(nval) {
      this.moveChannel(nval)
    },
    channels() {
      this.moveChannel(this.channel)
    },
    category() {
      this.moveChannel(this.channel)
    },
    activeChannel(nval) {
      _$.vue.$emit("channel-guide", nval)
    }
  },
  mounted() {
    _$.nav.sync("channel-list")
    if (this.channel) this.moveChannel(this.channel)
  },
  methods: {
    moveChannel($channel) {
      if (this.activeChannel === $channel) return

      const target = this.channels.findIndex(el => el === $channel)
      if (target >= 0) this.activeItem = target
      else this.activeItem = 0
    },
    moveList($e) {
      if ($e.detail.value === "down") this.activeItem++
      else if ($e.detail.value === "up") this.activeItem--
      else if ($e.detail.value === "ch_down") this.activeItem = this.activeItem - 7
      else if ($e.detail.value === "ch_up") this.activeItem = this.activeItem + 7

      if (this.activeItem >= this.channels.length) this.activeItem = 0
      else if (this.activeItem < 0) this.activeItem = this.channels.length - 1
    },
    focused() {
      if (!this.hasChannel) return _$.sleep(250).then(() => this.section("categories"))
      this.$store.state.live.sidebar = null
    },
    blured() {
      this.moveChannel(this.channel)
    },
    choose() {
      if (this.channel === this.activeChannel) return this.section(this.activeChannel.price && !this.activeChannel.owned ? null : "osd")
      this.$store.commit("live/channel", this.activeChannel)
    },
    section(to = null) {
      this.$emit("section", to)
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-list {
  display: flex;
  box-shadow: -7px 0px 15px 0px rgba(0, 0, 0, 0.75);
  left: 60px;

  .left-side {
    width: 450px;
    display: flex;
    flex-direction: column;

    .channel-item {
      height: 102px !important;
    }
    .activeItem {
      height: 108px !important;
    }
  }
  .right-side {
    flex-grow: 1;
    position: relative;
  }

  .nochannel {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    padding: 0 1em;
  }
}
</style>
